import { HttpClient } from "@/App/services/HttpClient";
import config from "@/App/config";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";

export default {
  secret(): Promise<any> {
    return handleHttpRequest(HttpClient.get(config.SECRET));
  },
  broadcastChannels(): Promise<any> {
    return handleHttpRequest(HttpClient.get(config.BROADCAST_CHANNELS));
  },

  broadcastHistory(): Promise<any> {
    return handleHttpRequest(HttpClient.get(config.BROADCAST_HISTORY));
  },
};
